import { statsConstants } from '../constants'

export const statsLoad = () => {
  return {
    type: statsConstants.STATS_LOAD
  }
}

export const statsLoadSuccess = (payload) => {
  return {
    type: statsConstants.STATS_LOAD_SUCCESS,
    payload
  }
}

export const statsLoadFailure = (payload) => {
  return {
    type: statsConstants.STATS_LOAD_FAILURE,
    payload
  }
}

export const statsReset = () => {
  return {
    type: statsConstants.STATS_RESET
  }
}

export const statsCampaignLoad = (payload) => {
  return {
    type: statsConstants.STATS_CAMPAIGN_LOAD,
    payload
  }
}

export const statsCampaignLoadSuccess = (payload) => {
  return {
    type: statsConstants.STATS_CAMPAIGN_LOAD_SUCCESS,
    payload
  }
}

export const statsCampaignLoadFailure = (payload) => {
  return {
    type: statsConstants.STATS_CAMPAIGN_LOAD_FAILURE,
    payload
  }
}
